@use '~/theme/theme' as *;

.wrapper {
  display: flex;
  align-items: center;
  align-self: flex-start;

  @include border-radius('sm');
}

.fullWidth {
  width: 100%;
}

.icon {
  flex-shrink: 0;
}

.info {
  background: color(violet-100);

  .icon {
    @include icon-size(sm);

    color: color(violet-600);
  }
}

.error {
  background: color(pink-100);

  .icon {
    color: color(lobster-800);
  }
}

.success {
  background: color(green-100);

  .icon {
    color: color(forest-700);
  }
}

.warning {
  background: color(orange-100);

  .icon {
    color: color(orange-800);
  }
}

.small {
  gap: spacing(1.5);
  padding: spacing(0.75) spacing(1.5);

  .icon {
    @include icon-size(sm);
  }
}

.medium {
  gap: spacing(1.5);
  padding: spacing(1) spacing(1.5);

  .icon {
    @include icon-size(sm);
  }
}

.large {
  gap: spacing(2);
  padding: spacing(1.5) spacing(2);

  .icon {
    @include icon-size(md);
  }
}

.withoutBox {
  background: none;
  padding: 0;
}

.content {
  flex-grow: 1;
  display: flex;
  align-items: center;
  min-width: 0;
}

.action {
  flex-shrink: 0;
}
